// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2024-09-29 00:09:53 +0200 (Sun, 29 Sep 2024) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 146416 $
// Purpose     : gndo dashboard panel panels
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Table} from 'semantic-ui-react'

// ---Framework imports
import {get, isArray} from 'ldash'
import {Sel} from 'uix/registries'
import log from 'uix/logging'
import {useApi, useCallApi} from 'uix/hooks'
import {DashSegment} from 'uix/components/grid'
import {Link, XMenu} from 'uix/components'
import {formatNumber} from 'uix/utils'
import {GndoInfo} from 'uix/frontend/components'

// ---Local imports

// ---Exports

export const NodeGndoInfo = {
  Comp: ({i18n, node}) => {
    let {callApi, calling} = useCallApi('gndo/syncFields')

    let {data, reload} = useApi(
      'gndo/getGndoRelatedIdentifiers',
      {otid: node.otid},
      {autoreset: false}
    )
    let relatedOutgoing = data?.relatedIdentifiers.outgoing || []
    let relatedIncoming = data?.relatedIdentifiers.incoming || []
    relatedIncoming = relatedIncoming.filter(
      incoming => !relatedOutgoing.some(outgoing => outgoing.otid == incoming.otid)
    )

    let buildItem = ({ident, relation, label, caption, otid}) => {
      let title = label || caption
      let link = otid ? <Link id={otid}>{title}</Link> : title
      let name_translated = i18n.get(`gndo_${relation}`, i18n.get(`gndo_${relation}AsLiteral`))
      return (
        <div key={`${ident}_${otid}`} style={{display: 'table-row'}}>
          <div style={{display: 'table-cell', paddingRight: '5px'}}>{name_translated}:</div>
          <div style={{display: 'table-cell'}}>{link}</div>
        </div>
      )
    }
    let menu = (
      <XMenu>
        <XMenu.Item
          icon={{name: 'refresh', loading: calling}}
          onClick={() => callApi({otid: node.otid}, reload)}
        />
      </XMenu>
    )
    return (
      <DashSegment header="GDN-Relationen" menu={menu}>
        <div style={{display: 'table', width: '100%'}}>
          {relatedOutgoing.map(buildItem)}
          {relatedIncoming.map(buildItem)}
        </div>
      </DashSegment>
    )
  },
  //~ align: 'right',
  acl: 'g:admin,g:qs',
  datatypes: ['name', 'place', 'subject'],
}

export const NodeGndoDetails = {
  Comp: ({node}) => {
    return (
      <DashSegment header="GDN-Details">
        <GndoInfo otid={node.otid} />
      </DashSegment>
    )
  },
  acl: 'g:admin,g:qs',
  datatypes: ['name', 'place', 'subject'],
  align: 'right',
}
